import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import {
  EAFormRequestBodyParams,
  EAGetPreferenceResponse,
  ReqBodyInitiatePayment,
  ReqBodyPaymentCallback,
  SubscriptionDetailsResponse,
} from './types';
import qs from 'qs';
import {STATUS} from '@jobseeker/common-core/constants';

const axiosSubscriptionGladiator = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/subscription`
);

const initiatePaymentGateway = async (
  reqBodyParams: ReqBodyInitiatePayment
) => {
  try {
    const response = await axiosSubscriptionGladiator.post(
      `/hash`,
      qs.stringify(reqBodyParams)
    );
    if (response[STATUS] === 200) {
      console.log('hash API ', response?.data?.data);
      return response?.data?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

export const paymentCallbackAPI = async (
  reqBodyParams: ReqBodyPaymentCallback,
  token: string
) => {
  try {
    const response = await axiosSubscriptionGladiator.post(
      ``,
      qs.stringify(reqBodyParams),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    if (response[STATUS] === 200) {
      return response?.data?.data;
    }
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const getPreference = async (): Promise<EAGetPreferenceResponse> => {
  try {
    const response: any = await axiosSubscriptionGladiator.get(
      `/early-applicant-preference`,
      {
        withCredentials: true,
        headers: {
          'Cache-Control': 'no-cache',
        },
      }
    );
    if (response[STATUS] === 200) {
      return response?.data?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const updatePreference = async (
  EAPreferenceUpdationParams: EAFormRequestBodyParams
): Promise<EAGetPreferenceResponse> => {
  try {
    const response: any = await axiosSubscriptionGladiator.post(
      `/early-applicant-preference`,
      EAPreferenceUpdationParams,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    if (response[STATUS] === 200) {
      return response?.data?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const subscriptionDetails = async (
  token: string
): Promise<SubscriptionDetailsResponse> => {
  try {
    const response: any = await axiosSubscriptionGladiator.get(`/details`, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response[STATUS] === 200) {
      return response?.data?.data;
    }
    return {
      earlyApplicant: {active: false, expiry: ''},
      resumeBuilder: {active: false, expiry: ''},
    };
  } catch (error: any) {
    console.error(error);
    return {
      earlyApplicant: {active: false, expiry: ''},
      resumeBuilder: {active: false, expiry: ''},
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const subscriptionService = {
  initiatePaymentGateway,
  paymentCallbackAPI,
  getPreference,
  updatePreference,
  subscriptionDetails,
};

export default subscriptionService;
